import {regionIsoEnum} from "@/core/enums/regionIsoEnum";

/**
 * we don't use region path for Germany
 * @returns {boolean}
 */
export function isRegionGermany() {
    return !process.env.MIX_REGION_PATH;
}

/**
 * @returns {boolean}
 */
export function isRegionAustria() {
    return process.env.MIX_REGION_PATH === regionIsoEnum.AUSTRIA;
}

/**
 * @returns {boolean}
 */
export function isRegionAustralia() {
    return process.env.MIX_REGION_PATH === regionIsoEnum.AUSTRALIA;
}
